<!-- 注册用户接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "nickName": "会飞的猪",
                "phone": "18054103169",
                "allowOtherPay": 1,
                "pushWeixinMsg": 1,
                "pushAppMs": 1
            },
            responseCode: {
                "data": {
                    "userId": 3480
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台注册用户",
                t_url: this.commonUrls.test+"registerUser",
                p_url: this.commonUrls.prod+"registerUser",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'nickName', info2: '否', info3: 'String', info4: '用户呢称' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' },
                        { info1: 'allowOtherPay', info2: '是', info3: 'Integer', info4: '是否允许他人代缴，1允许 0不允许' },
                        { info1: 'pushWeixinMsg', info2: '是', info3: 'Integer', info4: '是否推送微信消息，1推送 0不推送' },
                        { info1: 'pushAppMs', info2: '是', info3: 'Integer', info4: '是否推送app消息，1推送 0不推送' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '用户ID' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/registerUser.vue